<template>
  <div class="comp-ly-transfer">
    <jw-card :title="$t('可选')" class="transfer-card">
      <div
        class="settingContainer"
        :style="{
          height: props.cmpHeight + 'px'
        }"
      >
        <div v-if="selectOptions.length > 0">
          <div :class="{ active: item.value === activeValue }" class="settingContainer-list" v-for="(item, index) in selectOptions" :key="index">
            <jw-tooltip position="bottom" mini :content="item.label">
              <div class="label-con" @click="changeSelect(item)">{{ item.label }}</div>
            </jw-tooltip>
          </div>
        </div>
        <div v-else>
          <jw-empty />
        </div>
      </div>
    </jw-card>
    <div class="setting-control">
      <icon-right size="20" style="color: #888; cursor: pointer" @click="handleSelect('add')" class="control-icon" />
      <icon-left size="20" style="color: #888; cursor: pointer" @click="handleSelect('remove')" class="control-icon" />
    </div>
    <jw-card :title="$t('已选')" class="transfer-card">
      <div
        class="settingContainer"
        :style="{
          height: props.cmpHeight + 'px'
        }"
      >
        <div v-if="selectedRef.length > 0">
          <draggable animation="300" v-model="selectedRef" group="site" :sort="true" @start="onStart" @end="onEnd">
            <template #item="{ element }">
              <div class="draggable-item" :class="{ active: element.value === activeValue }" @click="changeSelect(element)">
                <icon-drag-dot-vertical class="mover hand" />
                <jw-tooltip position="bottom" mini :content="element.label">
                  <div class="draggable-list">
                    {{ element.label }}
                  </div>
                </jw-tooltip>
              </div>
            </template>
          </draggable>
        </div>
        <div v-else>
          <jw-empty />
        </div>
      </div>
    </jw-card>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import draggable from 'vuedraggable';
const drag = ref(false); //拖拽

const emits = defineEmits(['cb']);
const props = defineProps({
  options: {
    type: Array,
    default: () => [
      {
        name: '编辑',
        code: 'edit'
      },
      {
        name: '转化',
        code: 'transfer'
      },
      {
        name: '复制',
        code: 'copy'
      },
      {
        name: '废弃',
        code: 'cancel'
      }
    ]
  },
  selected: {
    type: Array,
    default: () => []
  },
  feildKey: {
    type: String,
    default: 'code'
  },
  cmpHeight: {
    type: Number,
    default: 400
  },
  index: {
    type: Number,
    default: null
  }
});

const activeValue = ref();
const selectOptions = ref([]);
const selectedRef = ref([]);

const onStart = (e, tp) => {
  console.log(177, e, tp);
  drag.value = true;
  return true;
};
const onEnd = (e, tp) => {
  console.log(178, e, tp);
  drag.value = false;
  emits('cb', selectedRef.value, props.index);
};

// 已选按钮
watch(
  () => [props.selected, props.options],
  () => {
    console.log('可选按钮11', props.selected);
    console.log('可选按钮22', props.options);

    const canUseBtnList = [];
    const selectedBtnList = [];
    const selectedList = [...props.selected]?.filter(Boolean);
    const allOptions = [...props.options];

    if (props.selected && props.selected.length && selectedList.length) {
      selectedList.forEach((selectedItem) => {
        const selectedBtn = allOptions.find((option) => option.value === selectedItem?.value);
        if (selectedBtn) {
          selectedBtnList.push(selectedBtn);
        }
      });

      allOptions.forEach((allItem) => {
        const isSelected = selectedList.some((selectItem) => selectItem.value === allItem.value);
        if (!isSelected) {
          canUseBtnList.push(allItem);
        }
      });
      selectedRef.value = selectedBtnList;
      selectOptions.value = canUseBtnList;
    } else {
      selectOptions.value = [...props.options];
      selectedRef.value = [];
    }
  },
  {
    deep: true,
    immediate: true
  }
);

const changeSelect = (item) => {
  activeValue.value = item.value;
};

const handleSelect = (type) => {
  if (activeValue.value) {
    if (type === 'add') {
      const handleIndex = selectOptions.value.findIndex((item) => item.value === activeValue.value);
      if (handleIndex > -1) {
        const handleItem = selectOptions.value.splice(handleIndex, 1);
        selectedRef.value.push(handleItem[0]);
      }
    }
    // 去props原数据中匹配,恢复到原来的位置
    if (type === 'remove') {
      const handleitem = selectedRef.value.find((item) => item.value === activeValue.value);
      const handleIndex = selectedRef.value.findIndex((item) => item.value === activeValue.value);

      if (handleitem) {
        selectedRef.value.splice(handleIndex, 1);
        const _place = selectOptions.value.findIndex((item) => item.value === handleitem.value);
        selectOptions.value.splice(_place, 0, handleitem);
      }
    }
    activeValue.value = null;
    emits('cb', selectedRef.value, props.index);
  }
};
</script>
<style scoped lang="less">
@import './ly-transfer.less';
</style>
